export default "__VITE_ASSET__$NjoyLhL__"